import { Box, Colors, IcAccount, IcChevronDown, IcMenu, IcMenuHide, IcNotification, IcMenuClockOut, Row, Text } from 'basic-ui-lib';
import styled from 'styled-components';
import logo from 'assets/logo.svg';
import logoMobile from 'assets/logo-mobile.svg';
import { useSidebar } from 'layouts/SidebarLayout/useSidebar';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { useAppDispatch } from 'store/hooks';
import authActions from 'modules/auth/services/actions';
import storage from 'utils/sessionStorage';
import { useMediaQuery } from 'react-responsive';

interface HeaderProps {}

const Header = ({}: HeaderProps) => {
  const { toggleSidebar, open } = useSidebar();
  const dispatch = useAppDispatch();
  const userName = storage.username.get() || 'User';
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const handleSignOut = () => {
    dispatch(authActions.logout.fetch());
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'signout',
      label: (
        <DropdownItem onClick={handleSignOut}>
          <IcMenuClockOut width={24} height={24} />
          <Text body_1 color="neutral.text.5">Sign Out</Text>
        </DropdownItem>
      ),
    },
  ];

  if (isMobile) {
    return (
      <Row padding='10px 16px' justifyContent='flex-start' backgroundColor={Colors.neutral.bg[6]}>
        <img src={logoMobile} alt='Logo' width={120} height={32} />
      </Row>
    );
  } 

  return (
    <Container>
      <Row gap={16} alignItems='center'>
        <button onClick={toggleSidebar} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
          { open ? <IcMenu /> : <IcMenuHide /> }
        </button>
        <img src={logo} alt='Logo' width={120} height={40}/>
      </Row>
      <Row gap={24} alignItems='center'>
        <IcNotification width={24} height={24} />
        <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
          <UserDropdown>
            <Box
              display='flex'
              justifyContent='center'
              alignItems='center'
              width={40}
              height={40}
              backgroundColor={Colors.primary[5]}
              borderRadius='50%'
            >
              <IcAccount fill={Colors.neutral.bg[1]} width={20} height={20} />
            </Box>
            <Text body_1>
              {userName}
            </Text>
            <IcChevronDown width={16} height={16} />
          </UserDropdown>
        </Dropdown>
      </Row>
    </Container>
  );
};

export default Header;

// ================= styled =================
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${Colors.neutral.bg[3]};
  position: sticky;
  top: 0;
  padding: 10px 16px;
  z-index: 10;
`;

const UserDropdown = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  min-width: 185px;
  cursor: pointer;
`;

